import {
  signingCompanyAuthorizedSignerTypeOption,
  signingLoanOfficerSignerTypeOption,
  signingSecurityGroupSignerTypeOption,
  signingSignerTypeOptions,
  signingTagsOptions,
  signingTpoAuthorizedSignerTypeOption,
} from 'constants/formBuilder';
import { floatOptions } from 'constants/options';

export const ANCHOR_VERTICAL_OFFSET_PX = 4;

export const EMPTY_STYLE = Object.freeze({});
export const IMAGE_DEFAULT_STYLE = Object.freeze({ size: 100, float: floatOptions[0].value });

export const PRISM_DEFAULT_FONT_FAMILY_OPTION = Object.freeze({ name: 'Auto', value: 0 });
export const PRISM_FONT_FAMILY_OPTIONS = Object.freeze([
  PRISM_DEFAULT_FONT_FAMILY_OPTION,
  ...[
    'Arial',
    'Book Antiqua',
    'Calibri',
    'Cambria',
    'Comic Sans MS',
    'Courier New',
    'Garamond',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Palatino Linotype',
    'Segoe UI',
    'Tahoma',
    'Times New Roman',
    'Trebuchet MS',
    'Verdana',
  ].map(family => ({ name: family, value: family })),
]);

export const SIGNATURE_CKEDITOR_ONLY_KEYS = new Set(['isNewItem', 'isEdit']);

export const SIGNER_NAMES_BY_VALUE = new Map(
  [
    ...signingSignerTypeOptions,
    signingLoanOfficerSignerTypeOption,
    signingCompanyAuthorizedSignerTypeOption,
    signingSecurityGroupSignerTypeOption,
    signingTpoAuthorizedSignerTypeOption,
  ].map(({ name, value }) => [value, name]),
);
export const TAG_NAMES_BY_VALUE = new Map(
  signingTagsOptions.map(({ name, value }) => [value, name]),
);

export const PRISM_SIGNATURE_LABELS = Object.freeze({
  tagNames: TAG_NAMES_BY_VALUE,
  signerNames: SIGNER_NAMES_BY_VALUE,
});
